import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; 

const firebaseConfig = {
    apiKey: "AIzaSyBPxx6qI4rWxtbhYmRg9exmrSzis9LUUgs",
    authDomain: "noltrade.firebaseapp.com",
    projectId: "noltrade",
    storageBucket: "noltrade.firebasestorage.app",
    messagingSenderId: "706148887949",
    appId: "1:706148887949:web:aa754ee4599243ae1f61c4",
    measurementId: "G-W7CBFLRTHB"
  };

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Crear instancia de auth y Google provider
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app); //